import styled from 'styled-components';

export const InnerPageContainer = styled.div`
  background-color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N200
      : props.theme.atlas.core.color.gray[100]};
  padding: 20px;
  padding-bottom: 0;
`;

export const PageContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  font-family: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.typography.fontFamily
      : props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  font-weight: 100;

  * {
    box-sizing: border-box;
  }

  @media (max-width: ${(props) => props.theme.newBreakpoints.narrow}px) {
    margin-top: 60px;
  }
`;

export const PageContentContainer = styled.div<{ moveLeft?: boolean }>`
  height: 100vh;
  width: 100vw;
  background-color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N200
      : props.theme.atlas.core.color.gray[100]};
  overflow: auto;
  display: flex;
  flex-direction: column;
  margin-left: ${(props) => (props.moveLeft ? '190px' : '0')};

  @media screen and (max-width: 899px) {
    margin-left: 0px;
  }
`;
